// extracted by mini-css-extract-plugin
module.exports = {"all":"e_Dp","accent":"e_Ep"};